var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconresume = function SvgIconresume(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon.resume",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172,
    height: 178.25,
    viewBox: "0 0 172 178.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4115",
    x: 33,
    y: 6.25,
    width: 110,
    height: 140,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    transform: "translate(-441 -766.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 441, 766.75)",
    filter: "url(#Rectangle_4115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4115-2",
    "data-name": "Rectangle 4115",
    width: 92,
    height: 122,
    rx: 1,
    transform: "translate(42 14.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4117",
    "data-name": "Rectangle 4117",
    width: 53,
    height: 6,
    rx: 3,
    transform: "translate(492 791)",
    fill: "#4c92bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4118",
    "data-name": "Rectangle 4118",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 808)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4119",
    "data-name": "Rectangle 4119",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 821)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4120",
    "data-name": "Rectangle 4120",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 834)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6843",
    "data-name": "Rectangle 6843",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 847)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6844",
    "data-name": "Rectangle 6844",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 860)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6847",
    "data-name": "Rectangle 6847",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 873)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 6,
    rx: 3,
    transform: "translate(492 886)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5927",
    "data-name": "Rectangle 5927",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(544 808)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6845",
    "data-name": "Rectangle 6845",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(544 821)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6846",
    "data-name": "Rectangle 6846",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(544 834)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6848",
    "data-name": "Rectangle 6848",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(544 847)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6849",
    "data-name": "Rectangle 6849",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(544 860)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(553 786)",
    fill: "#005b92"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-thumbs-up",
    transform: "translate(141.5 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M30.5,17.25A13.25,13.25,0,1,1,17.25,4,13.251,13.251,0,0,1,30.5,17.25Z",
    fill: "#7fb1cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M16.6,15.8l3.709,1.856L21.5,15.53a7.386,7.386,0,0,0,.926-3.576v-.595A1.471,1.471,0,0,0,20.973,9.9h-.331a.566.566,0,0,0-.531.466l-.331,1.325a3.744,3.744,0,0,1-.859,1.589Z",
    transform: "translate(-4.253 -1.991)",
    fill: "#fac17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M24.806,28.6H17.65A2.659,2.659,0,0,1,15,25.95v-5.3A2.659,2.659,0,0,1,17.65,18h8.612a1.327,1.327,0,0,1,1.325,1.325c0,.73-.331.994-.331,1.325s.331.595.331,1.325-.531,1.193-.595,1.524c-.134.4.065,1.059-.134,1.524s-.595.727-.663,1.191.2.994,0,1.524A1.724,1.724,0,0,1,24.806,28.6Z",
    transform: "translate(-3.713 -4.725)",
    fill: "#fac17c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-thumbs-up-2",
    "data-name": "icons8-thumbs-up",
    transform: "translate(120 107.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761-2",
    "data-name": "Path 4761",
    d: "M47,25.5A21.5,21.5,0,1,1,25.5,4,21.5,21.5,0,0,1,47,25.5Z",
    fill: "#7fb1cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762-2",
    "data-name": "Path 4762",
    d: "M16.6,19.469,22.62,22.48l1.935-3.444a11.985,11.985,0,0,0,1.5-5.8v-.965A2.386,2.386,0,0,0,23.694,9.9h-.537a.918.918,0,0,0-.861.756l-.537,2.15a6.076,6.076,0,0,1-1.393,2.578Z",
    transform: "translate(0.945 0.442)",
    fill: "#fac17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763-2",
    "data-name": "Path 4763",
    d: "M30.911,35.2H19.3A4.314,4.314,0,0,1,15,30.9V22.3A4.314,4.314,0,0,1,19.3,18H33.275a2.154,2.154,0,0,1,2.15,2.15c0,1.185-.537,1.612-.537,2.15s.537.965.537,2.15-.861,1.936-.965,2.474c-.218.643.105,1.718-.218,2.474s-.965,1.18-1.075,1.932.324,1.612,0,2.474A2.8,2.8,0,0,1,30.911,35.2Z",
    transform: "translate(0.825 1.05)",
    fill: "#fac17c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-thumbs-up-3",
    "data-name": "icons8-thumbs-up",
    transform: "translate(-4 56.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761-3",
    "data-name": "Path 4761",
    d: "M41,22.5A18.5,18.5,0,1,1,22.5,4,18.5,18.5,0,0,1,41,22.5Z",
    fill: "#7fb1cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762-3",
    "data-name": "Path 4762",
    d: "M16.6,18.133l5.178,2.591,1.665-2.964a10.313,10.313,0,0,0,1.293-4.993v-.831A2.053,2.053,0,0,0,22.7,9.9h-.462a.79.79,0,0,0-.741.65l-.462,1.85a5.228,5.228,0,0,1-1.2,2.218Z",
    transform: "translate(-0.945 -0.442)",
    fill: "#fac17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763-3",
    "data-name": "Path 4763",
    d: "M28.691,32.8H18.7A3.712,3.712,0,0,1,15,29.1V21.7A3.712,3.712,0,0,1,18.7,18H30.725a1.853,1.853,0,0,1,1.85,1.85c0,1.019-.462,1.387-.462,1.85s.462.831.462,1.85-.741,1.666-.831,2.128c-.188.553.091,1.478-.188,2.128s-.831,1.016-.925,1.662.278,1.387,0,2.128A2.407,2.407,0,0,1,28.691,32.8Z",
    transform: "translate(-0.825 -1.05)",
    fill: "#fac17c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-thumbs-up-4",
    "data-name": "icons8-thumbs-up",
    transform: "translate(18 143.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761-4",
    "data-name": "Path 4761",
    d: "M35,19.5A15.5,15.5,0,1,1,19.5,4,15.5,15.5,0,0,1,35,19.5Z",
    fill: "#7fb1cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762-4",
    "data-name": "Path 4762",
    d: "M16.6,16.8l4.338,2.171,1.4-2.483A8.641,8.641,0,0,0,23.419,12.3v-.7a1.72,1.72,0,0,0-1.7-1.707h-.387a.662.662,0,0,0-.621.545l-.388,1.55a4.38,4.38,0,0,1-1,1.858Z",
    transform: "translate(-2.835 -1.327)",
    fill: "#fac17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763-4",
    "data-name": "Path 4763",
    d: "M26.471,30.4H18.1A3.11,3.11,0,0,1,15,27.3V21.1A3.11,3.11,0,0,1,18.1,18H28.175a1.553,1.553,0,0,1,1.55,1.55c0,.854-.387,1.162-.387,1.55s.387.7.387,1.55-.621,1.4-.7,1.783c-.157.463.076,1.238-.157,1.783s-.7.851-.775,1.393.233,1.162,0,1.783A2.016,2.016,0,0,1,26.471,30.4Z",
    transform: "translate(-2.475 -3.15)",
    fill: "#fac17c"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconresume);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.resume.81492df83bf1b5c658107860ffeb8d9d.svg";